import { render, staticRenderFns } from "./PointView.vue?vue&type=template&id=03ce8b31"
import script from "./PointView.js?vue&type=script&lang=js&external"
export * from "./PointView.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports